// Aviso (não-trava) do ciclo bimestral da Avaliação 360.
//
// A 360 e a "Auditoria Financeira e de Estoques" são BIMESTRAIS e se alternam
// (cada uma cai no mês contrário à outra — spec DEM-00011). Este helper só mostra
// um LEMBRETE do ciclo; NÃO bloqueia o preenchimento (não há UNIQUE por
// loja/bimestre; o consultor pode preencher quando precisar).
//
// ⚠️ O CICLO AINDA NÃO COMEÇOU (decisão da Julia, 2026-09-22): NÃO assumimos de
// quem é a vez em mês par/ímpar. Os Consultores de Operações escolhem o mês de
// partida quando iniciarem o processo — e a partir daí a rede segue o padrão.
// Enquanto isso, o aviso é neutro. Quando a âncora for definida, dá para derivar
// de quem é a vez a partir dela aqui (sem tocar nas telas).
function avisoCicloBimestral() {
  return {
    texto: 'A Avaliação 360 e a Auditoria Financeira e de Estoques se alternam a cada mês (uma em cada). O mês de início do ciclo será definido pelos Consultores de Operações — a partir daí a rede segue o padrão.',
  };
}

export { avisoCicloBimestral };
